"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryTxFeesBaseDenom = void 0;
const chain_query_1 = require("../../../chain-query");
const mobx_1 = require("mobx");
class ObservableQueryTxFeesBaseDenom extends chain_query_1.ObservableChainQuery {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, "/osmosis/txfees/v1beta1/base_denom");
        mobx_1.makeObservable(this);
    }
    get baseDenom() {
        var _a, _b;
        return (_b = (_a = this.response) === null || _a === void 0 ? void 0 : _a.data.base_denom) !== null && _b !== void 0 ? _b : "";
    }
}
exports.ObservableQueryTxFeesBaseDenom = ObservableQueryTxFeesBaseDenom;
//# sourceMappingURL=index.js.map